import styled from 'styled-components';
import { 
    TABLET,
    MOBILE
} from '@minerva-analytics/pantheon';

import { GRAY } from '../../theme';

const BodyText = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.68px;
  color: ${GRAY};
  @media (max-width: ${TABLET}) {
    width: 90%;
    text-align: left;
  }
  line-height: 33px;
`;


const TypeformContainer = styled.div`
  position: relative;
  width: 110%;
  margin-left: -3rem;
  margin-top: -1rem;
  min-height: 45rem;

  @media (max-width: ${MOBILE}) {
    margin-left: -1rem;
  }
  iframe {
    min-height: 45rem;
  }
`;

export { BodyText, TypeformContainer };
